module.exports = __webpack_public_path__ + "static/media/close-icon.f152dcb0.svg";